import React from 'react';
import { Dialog } from 'primereact/dialog';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import { AddProfessorsDialogContent } from './components/add-professors-dialog-content';

interface AddProfessorsDialogProps {
  visible: boolean;
  onHide: () => void;
  alreadySelectedProfessors: UserSummaryType[];
  onApprove: (selectedProfessors: UserSummaryType[]) => void;
}

export const AddProfessorsDialog: React.FC<AddProfessorsDialogProps> = ({
  visible,
  onHide,
  alreadySelectedProfessors,
  onApprove,
}) => {
  return (
    <Dialog
      header={'הוספת מרצים'}
      visible={visible}
      style={{
        height: '100vh',
        width: '800px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      onHide={onHide}
    >
      <div style={{ marginTop: '20px' }}>
        <AddProfessorsDialogContent
          visible={visible}
          alreadySelectedProfessors={alreadySelectedProfessors}
          onApprove={onApprove}
          onHide={onHide}
        />
      </div>
    </Dialog>
  );
};
